export function PopupSeparator() {
  return <div className="border-border my-1 h-[1px] w-full border-b" />;
}
